export enum FeatureFlagName {
  AiQuickReply = 'AiQuickReply',
  AppointmentsPageImprovements = 'AppointmentsPageImprovements',
  AutoEODPayoutControls = 'AutoEODPayoutControls',
  AutomationsConditionalChildOptionVisibility = 'AutomationsConditionalChildOptionVisibility',
  AutomationsPageVisibility = 'AutomationsPageVisibility',
  AutomationsPatientAgeSendCondition = 'AutomationsPatientAgeSendCondition',
  BitwerxPaymentWritebacks = 'BitwerxPaymentWritebacks',
  BoardViewShowQuickSelectDateOptions = 'BoardViewShowQuickSelectDateOptions',
  CallDeflection = 'CallDeflection',
  CareCredit = 'CareCredit',
  CarePlans = 'CarePlans',
  ConditionEngineWorkflowMatching = 'ConditionEngineWorkflowMatching',
  ConversationsPerformanceImprovements = 'ConversationsPerformanceImprovements',
  DirectBooking = 'DirectBooking',
  DirectBookingCreateClientAndPatient = 'DirectBookingCreateClientAndPatient',
  DirectBookingOffHourStartTime = 'DirectBookingOffHourStartTime',
  DisableAutoRefresh = 'DisableAutoRefresh',
  DisplayWidgetRequestVisibility = 'DisplayWidgetRequestVisibility',
  EnablePendo = 'EnablePendo',
  EnableServiceRemindersForEzyVet = 'EnableServiceRemindersForEzyVet',
  EODPayoutControls = 'EODPayoutControls',
  EtlConfirmAppointmentWriteback = 'EtlConfirmAppointmentWriteback',
  FlexPayUpdates = 'FlexPayUpdates',
  FlowAppointmentCreationPimsWriteback = 'FlowAppointmentCreationPimsWriteback',
  IntegratedTAP = 'IntegratedTAP',
  InvoiceDiscovery = 'InvoiceDiscovery',
  LiveAgent = 'LiveAgent',
  LoyaltyProgram = 'LoyaltyProgram',
  NpsSurvey = 'NpsSurvey',
  OfficeHourSync = 'OfficeHourSync',
  OttoRecapAppointment = 'OttoRecapAppointment',
  ServiceRemindersPushNotifications = 'ServiceRemindersPushNotifications',
  SortConversationByLastMessage = 'SortConversationByLastMessage',
  StripeBillingPortal = 'StripeBillingPortal',
  SurchargeOnStripeTerminal = 'SurchargeOnStripeTerminal',
  SurchargeUpdates = 'SurchargeUpdates',
  Tasks = 'Tasks',
  TerminalPaymentsApp = 'TerminalPaymentsApp',
  TrupanionCheckout = 'TrupanionCheckout',
  TrupanionDigitalCheckout = 'TrupanionDigitalCheckout',
  TwilioNewPhoneCallExperience = 'TwilioNewPhoneCallExperience',
  UseBandwidthHostingForSMS = 'UseBandwidthHostingForSMS',
  WizardPaymentIntegrations = 'WizardPaymentIntegrations',
  ShowBandwidthHostingButton = 'ShowBandwidthHostingButton', // To be removed once Twilio Hosting is situated
}
